import { DownloadOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, DatePickerProps, Row } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useDispatch } from "react-redux";
import { toast } from 'react-toastify';
import { xuatExcelXepLoaiTrongNam } from '../../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import ThuNhapNhanVien from './ThuNhapNhanVien';
import NguoiPhuThuocThongKe from './NguoiPhuThuocThongKe';
import NhanSuChuyenXepLuongThongKe from './NhanSuChuyenXepLuongThongKe';

const XepLoaiNhanVien = () => {
    const dispatch = useDispatch();

    const [nam, setNam] = useState<string>(new Date().getFullYear().toString());
    const [namValue, setNamValue] = useState<Dayjs | null>(dayjs());
    const namFormat: DatePickerProps['format'] = (value) => `Năm ${value.format('YYYY')}`;

    const onClick = async () => {
        try {
            dispatch(showLoadingScreen());
            var response = await xuatExcelXepLoaiTrongNam(parseInt(nam));
            let link = document.createElement('a');
            link.download = `ThongKeXepLoaiHangThang.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
            dispatch(hideLoadingScreen());
        }
        catch (err: any) {
            toast.error('Đã xảy ra lỗi, vui lòng thử lại!');
            dispatch(hideLoadingScreen());
        }
    };
    const onChange: DatePickerProps['onChange'] = (year) => {
        var yearStr = year?.format('YYYY');
        setNamValue(year);
        if (yearStr) {
            setNam(yearStr);
        } else {
            setNam("");
        }
    }

    return (
        <div style={{ marginTop:"23px" }}>
            <Row gutter={10}>
                <Col span={4}>
                    <label>Xếp loại KPI:</label>
                </Col>
                <Col span={5}>
                    <DatePicker changeOnBlur={true} value={namValue} style={{ width: "100%" }} placeholder="Năm" picker="year" format={namFormat} onChange={onChange} allowClear={false} />
                </Col>
                <Col>
                    <Button
                        className="hrm-btn hrm-btn-success"
                        htmlType="submit"
                        icon={<DownloadOutlined />}
                        onClick={onClick}
                    >Xuất excel
                    </Button>
                </Col>
            </Row>
            <ThuNhapNhanVien />
            <NguoiPhuThuocThongKe />
            <NhanSuChuyenXepLuongThongKe />
        </div>
    );
};

export default XepLoaiNhanVien;
